var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenario({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9 0.500001C0.661305 0.500001 0.432387 0.59407 0.263604 0.761513C0.0948213 0.928956 0 1.15606 0 1.39286V24.6071C0 24.8439 0.0948213 25.071 0.263604 25.2385C0.432387 25.4059 0.661305 25.5 0.9 25.5H17.1C17.3387 25.5 17.5676 25.4059 17.7364 25.2385C17.9052 25.071 18 24.8439 18 24.6071V7.64286C18.0002 7.52553 17.9771 7.40931 17.932 7.30084C17.8869 7.19237 17.8207 7.09378 17.7372 7.01071L11.4372 0.760716C11.3535 0.677855 11.2541 0.61218 11.1448 0.567445C11.0354 0.52271 10.9183 0.499792 10.8 0.500001H0.9ZM14.9274 6.75L11.7 3.54822V6.75H14.9274ZM8.1 8.53572H3.6V6.75H8.1V8.53572ZM14.4 13.8929H3.6V12.1071H14.4V13.8929ZM3.6 19.25H14.4V17.4643H3.6V19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario);
export default __webpack_public_path__ + "static/media/scenario.444339b4ee27e53464ddeb64fb5a111b.svg";
export { ForwardRef as ReactComponent };